import React from "react";
import utils from "../../universal/utils";

// Caller's own active RSVPs (pending/confirmed/waitlisted), each paired with
// the night's live counts, so authenticated surfaces (e.g. the lobby) can
// show "you're already signed up" state without re-deriving it client-side.
export default function useMyMatchNights() {
  const [myRsvps, setMyRsvps] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const hasLoadedRef = React.useRef(false);
  const basePath = React.useMemo(() => utils.getEdgeBasePath(), []);

  const fetchMyRsvps = React.useCallback(() => {
    if (!hasLoadedRef.current) setLoading(true);
    return fetch(`${basePath}/api/v1/match-nights/my-rsvps`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.ok) setMyRsvps(data.items || []);
      })
      .catch(() => {})
      .finally(() => {
        hasLoadedRef.current = true;
        setLoading(false);
      });
  }, [basePath]);

  React.useEffect(() => {
    let cancelled = false;
    fetchMyRsvps().then(() => {
      if (cancelled) return;
    });
    return () => {
      cancelled = true;
    };
  }, [fetchMyRsvps]);

  return { myRsvps, loading, basePath, refetch: fetchMyRsvps };
}
